module.exports = {
          srcSet: __webpack_public_path__ + "public/images/c989f69befa4c3ec6937910ad20c50eb-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/c989f69befa4c3ec6937910ad20c50eb-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/c989f69befa4c3ec6937910ad20c50eb-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/c989f69befa4c3ec6937910ad20c50eb-1774.webp"},
          
          width: 1774,
          height: 887
        }